import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-play",
  "use": "n-icon-play-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-play\">\n    <path d=\"M22.0887 13.6538C23.1149 14.2581 23.1149 15.7423 22.0887 16.3466L11.1054 22.8147C10.0638 23.4281 8.75 22.6771 8.75 21.4683V8.53216C8.75 7.32335 10.0638 6.57238 11.1054 7.18578L22.0887 13.6538Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol